import {displayShortDate} from "@ui-kit/framework/util/static/date-format-utils";
import {displayListAsString, displayString} from "@ui-kit/framework/util/static/string-format-util";
import {
  Date,
  DefaultSearchTerms,
  DisplayFunction,
  DisplayOrder,
  ExportFunction,
  Number,
  Percentage,
  SortDefault,
  String,
  TableDisplayedDefault
} from "@ui-kit/webkit/components/crud-item/crud-item-decorator";
import {SelectableIndustry} from "../../../settings/industries/industry.model";
import {ApplicationAssessmentStatus, Retailer, RetailerIndustry} from "../../retailers/retailers.model";

type CrudApplicationsModel = Pick<Retailer,
  "id" |
  "companyName" |
  "createDate" |
  "websiteUrl" |
  "curationAssessment" |
  "ownerFirstname" |
  "ownerLastname" |
  "industries"
>;

@DefaultSearchTerms(['progress:submitted'])
export class CrudApplications implements CrudApplicationsModel {

  @DisplayOrder(1)
  @TableDisplayedDefault
  @Number("ID")
  id?: number;

  @DisplayOrder(2)
  @DisplayFunction(displayShortDate)
  @ExportFunction(displayShortDate)
  @TableDisplayedDefault
  @Date("Application Date", "YYYY-MM-DD")
  @SortDefault("desc")
  createDate?: string | Date | undefined;

  @DisplayOrder(3)
  @TableDisplayedDefault
  @String("Company Name")
  companyName: string;

  @DisplayOrder(4)
  @TableDisplayedDefault
  @String("Retailer")
  retailerName?: string;

  @DisplayOrder(5)
  // @ClickFunction(openLinkInNewTab)
  @TableDisplayedDefault
  @String("Website")
  websiteUrl: string;

  @DisplayOrder(6)
  @DisplayFunction(displayString)
  @TableDisplayedDefault
  @String("Industry Type")
  industryType?: string;

  @Percentage("Overall Score")
  @DisplayOrder(7)
  @TableDisplayedDefault
  overallScore!: number | null;

  @DisplayOrder(8)
  @TableDisplayedDefault
  @String("Progress")
  curated!: string;

  ownerFirstname: string;
  ownerLastname: string;
  industries!: RetailerIndustry[];

  constructor(obj: any = {}, industries: SelectableIndustry[] = []) {
    obj = obj || {};
    this.id = obj.id;
    this.companyName = obj.companyName;
    this.createDate = obj.createDate;
    this.websiteUrl = obj.websiteUrl;
    this.ownerFirstname = obj.ownerFirstname;
    this.ownerLastname = obj.ownerLastname;
    this.retailerName = this.ownerFirstname + " " + this.ownerLastname;
    this.overallScore = obj.overallScore;
    this.curated = obj.curated == ApplicationAssessmentStatus.PENDING ? 'Submitted' : 'Incomplete';
    this.industries = obj.industries;

    if (obj.industries == null) {
      this.industryType = "";
    } else {
      const industryNameList: string[] = obj.industries
        .map((m: RetailerIndustry) => industries.find(f => f.id == m.industryTypeId))
        .filter((f: (SelectableIndustry | undefined)[]) => !!f)
        .map((m: SelectableIndustry) => m.labelNameOverride ?? m.name);
      this.industryType = displayListAsString(industryNameList);
    }
  }
}
